var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "183.96136mm",
    height: "147.90054mm",
    viewBox: "0 0 183.96136 147.90054",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-653.6584,-154.19955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer12",
    transform: "translate(630.76666,146.57917)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 25.537602,10.266214 V 152.8751",
    id: "path30543-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 75.767712,79.177058 H 34.867442",
    id: "path33075-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 85.094162,10.266214 V 152.8751",
    id: "path38690"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 144.65072,10.266214 V 152.8751",
    id: "path38692"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 194.66256,53.171728 H 153.76229",
    id: "path38694"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 194.66256,101.4406 H 153.76229",
    id: "path38696"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "M 204.20728,10.266214 V 152.8751",
    id: "path38698"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38054-7",
    width: 43.733643,
    height: 11.738361,
    x: 33.450756,
    y: 14.05576
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38805",
    width: 43.733643,
    height: 11.738361,
    x: 33.450756,
    y: 89.078316
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38807",
    width: 43.733643,
    height: 11.738361,
    x: 93.31913,
    y: 14.05576
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38809",
    width: 43.733643,
    height: 11.738361,
    x: 152.81332,
    y: 14.05576
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38811",
    width: 43.733643,
    height: 11.738361,
    x: 152.81332,
    y: 61.763371
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38813",
    width: 43.733643,
    height: 11.738361,
    x: 152.81332,
    y: 110.59351
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 34.424314,33.114694 c -0.483548,0.950454 -1.023823,1.907629 -1.122531,2.993419 -0.115321,1.268526 -0.202632,2.790788 0.748354,3.741774 0.305139,0.305139 1.881094,-0.479629 2.057976,-0.561266 0.759676,-0.35062 1.548899,-0.658423 2.245064,-1.122532 0.935352,-0.62357 1.958513,-1.727612 2.993418,-2.245066 0.939767,-0.469881 3.212119,-1.340715 4.303039,-1.122532 1.487776,0.297556 1.309621,4.124434 1.309621,5.051396 0,0.187087 0,0.374176 0,0.561266 0,0.06236 -0.06236,0.187087 0,0.187087 0.06236,0 -0.02789,-0.131308 0,-0.187087 0.100558,-0.201115 0.206121,-0.411882 0.374176,-0.561266 0.400961,-0.35641 0.917435,-0.569404 1.309622,-0.935445 0.548986,-0.512384 0.935445,-1.184894 1.496711,-1.683798 1.081233,-0.961096 4.69407,-3.554685 6.173925,-3.554685 0.199183,0 1.682773,2.921852 1.870887,3.180509 0.437306,0.601295 1.031512,0.983477 1.683798,1.309621 1.075872,0.537935 2.550273,-0.736221 3.554685,-1.122531 1.310904,-0.504196 2.88136,-0.999242 4.303037,-0.748356 1.731799,0.30561 1.877603,0.857819 3.554685,1.496708 1.584857,0.603756 3.190719,0.935445 4.864307,0.935445",
    id: "path38892"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 34.424314,45.020944 c -0.483548,0.950454 -1.023823,1.907629 -1.122531,2.993419 -0.115321,1.268526 -0.202632,2.790788 0.748354,3.741774 0.305139,0.305139 1.881094,-0.479629 2.057976,-0.561266 0.759676,-0.35062 1.548899,-0.658423 2.245064,-1.122532 0.935352,-0.62357 1.958513,-1.727612 2.993418,-2.245066 0.939767,-0.469881 3.212119,-1.340715 4.303039,-1.122532 1.487776,0.297556 1.309621,4.124434 1.309621,5.051396 0,0.187087 0,0.374176 0,0.561266 0,0.06236 -0.06236,0.187087 0,0.187087 0.06236,0 -0.02789,-0.131308 0,-0.187087 0.100558,-0.201115 0.206121,-0.411882 0.374176,-0.561266 0.400961,-0.35641 0.917435,-0.569404 1.309622,-0.935445 0.548986,-0.512384 0.935445,-1.184894 1.496711,-1.683798 1.081233,-0.961096 4.69407,-3.554685 6.173925,-3.554685 0.199183,0 1.682773,2.921852 1.870887,3.180509 0.437306,0.601295 1.031512,0.983477 1.683798,1.309621 1.075872,0.537935 2.550273,-0.736221 3.554685,-1.122531 1.310904,-0.504196 2.88136,-0.999242 4.303037,-0.748356 1.731799,0.30561 1.877603,0.857819 3.554685,1.496708 1.584857,0.603756 3.190719,0.935445 4.864307,0.935445",
    id: "path39083"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 34.424314,55.736569 c -0.483548,0.950454 -1.023823,1.907629 -1.122531,2.993419 -0.115321,1.268526 -0.202632,2.790788 0.748354,3.741774 0.305139,0.305139 1.881094,-0.479629 2.057976,-0.561266 0.759676,-0.35062 1.548899,-0.658423 2.245064,-1.122532 0.935352,-0.62357 1.958513,-1.727612 2.993418,-2.245066 0.939767,-0.469881 3.212119,-1.340715 4.303039,-1.122532 1.487776,0.297556 1.309621,4.124434 1.309621,5.051396 0,0.187087 0,0.374176 0,0.561266 0,0.06236 -0.06236,0.187087 0,0.187087 0.06236,0 -0.02789,-0.131308 0,-0.187087 0.100558,-0.201115 0.206121,-0.411882 0.374176,-0.561266 0.400961,-0.35641 0.917435,-0.569404 1.309622,-0.935445 0.548986,-0.512384 0.935445,-1.184894 1.496711,-1.683798 1.081233,-0.961096 4.69407,-3.554685 6.173925,-3.554685 0.199183,0 1.682773,2.921852 1.870887,3.180509 0.437306,0.601295 1.031512,0.983477 1.683798,1.309621 1.075872,0.537935 2.550273,-0.736221 3.554685,-1.122531 1.310904,-0.504196 2.88136,-0.999242 4.303037,-0.748356 1.731799,0.30561 1.877603,0.857819 3.554685,1.496708 1.584857,0.603756 3.190719,0.935445 4.864307,0.935445",
    id: "path39085"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 34.424314,108.52094 c -0.483548,0.95045 -1.023823,1.90763 -1.122531,2.99342 -0.115321,1.26852 -0.202632,2.79079 0.748354,3.74177 0.305139,0.30514 1.881094,-0.47963 2.057976,-0.56126 0.759676,-0.35062 1.548899,-0.65843 2.245064,-1.12254 0.935352,-0.62357 1.958513,-1.72761 2.993418,-2.24506 0.939767,-0.46988 3.212119,-1.34072 4.303039,-1.12253 1.487776,0.29755 1.309621,4.12443 1.309621,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.06236,0.18708 0,0.18708 0.06236,0 -0.02789,-0.1313 0,-0.18708 0.100558,-0.20112 0.206121,-0.41188 0.374176,-0.56127 0.400961,-0.35641 0.917435,-0.5694 1.309622,-0.93544 0.548986,-0.51239 0.935445,-1.1849 1.496711,-1.6838 1.081233,-0.9611 4.69407,-3.55469 6.173925,-3.55469 0.199183,0 1.682773,2.92186 1.870887,3.18051 0.437306,0.6013 1.031512,0.98348 1.683798,1.30962 1.075872,0.53794 2.550273,-0.73622 3.554685,-1.12253 1.310904,-0.50419 2.88136,-0.99924 4.303037,-0.74835 1.731799,0.30561 1.877603,0.85782 3.554685,1.4967 1.584857,0.60376 3.190719,0.93545 4.864307,0.93545",
    id: "path39087"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 95.013897,32.850112 c -0.483548,0.95045 -1.023823,1.90763 -1.122531,2.99342 -0.115321,1.26852 -0.202632,2.79079 0.748354,3.74177 0.305139,0.30514 1.881094,-0.47963 2.057976,-0.56126 0.759676,-0.35062 1.548899,-0.65843 2.245064,-1.12254 0.935352,-0.62357 1.95851,-1.72761 2.99342,-2.24506 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12253 1.48777,0.29755 1.30962,4.12443 1.30962,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18708 0,0.18708 0.0624,0 -0.0279,-0.1313 0,-0.18708 0.10056,-0.20112 0.20612,-0.41188 0.37417,-0.56127 0.40097,-0.35641 0.91744,-0.5694 1.30963,-0.93544 0.54898,-0.51239 0.93544,-1.1849 1.49671,-1.6838 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92186 1.87088,3.18051 0.43731,0.6013 1.03151,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.50419 2.88136,-0.99924 4.30303,-0.74835 1.7318,0.30561 1.87761,0.85782 3.55469,1.4967 1.58485,0.60376 3.19072,0.93545 4.8643,0.93545",
    id: "path39089"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 95.013897,44.359487 c -0.483548,0.95045 -1.023823,1.90763 -1.122531,2.99342 -0.115321,1.26852 -0.202632,2.79079 0.748354,3.74177 0.305139,0.30514 1.881094,-0.47963 2.057976,-0.56126 0.759676,-0.35062 1.548899,-0.65843 2.245064,-1.12254 0.935352,-0.62357 1.95851,-1.72761 2.99342,-2.24506 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12253 1.48777,0.29755 1.30962,4.12443 1.30962,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18708 0,0.18708 0.0624,0 -0.0279,-0.1313 0,-0.18708 0.10056,-0.20112 0.20612,-0.41188 0.37417,-0.56127 0.40097,-0.35641 0.91744,-0.5694 1.30963,-0.93544 0.54898,-0.51239 0.93544,-1.1849 1.49671,-1.6838 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92186 1.87088,3.18051 0.43731,0.6013 1.03151,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.50419 2.88136,-0.99924 4.30303,-0.74835 1.7318,0.30561 1.87761,0.85782 3.55469,1.4967 1.58485,0.60376 3.19072,0.93545 4.8643,0.93545",
    id: "path39091"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 154.80973,79.681361 c -0.48355,0.95045 -1.02382,1.90763 -1.12253,2.99342 -0.11532,1.26852 -0.20263,2.79079 0.74835,3.74177 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56126 0.75967,-0.35062 1.5489,-0.65843 2.24506,-1.12254 0.93535,-0.62357 1.95851,-1.72761 2.99342,-2.24506 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12253 1.48777,0.29755 1.30962,4.12443 1.30962,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18708 0,0.18708 0.0624,0 -0.0279,-0.1313 0,-0.18708 0.10056,-0.20112 0.20612,-0.41188 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.5694 1.30962,-0.93544 0.54898,-0.51239 0.93544,-1.1849 1.49671,-1.6838 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92186 1.87088,3.18051 0.43731,0.6013 1.03151,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.50419 2.88136,-0.99924 4.30303,-0.74835 1.7318,0.30561 1.87761,0.85782 3.55469,1.4967 1.58485,0.60376 3.19072,0.93545 4.8643,0.93545",
    id: "path39093"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 154.80973,128.76156 c -0.48355,0.95045 -1.02382,1.90763 -1.12253,2.99342 -0.11532,1.26852 -0.20263,2.79079 0.74835,3.74177 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56126 0.75967,-0.35062 1.5489,-0.65843 2.24506,-1.12254 0.93535,-0.62357 1.95851,-1.72761 2.99342,-2.24506 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12253 1.48777,0.29755 1.30962,4.12443 1.30962,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18708 0,0.18708 0.0624,0 -0.0279,-0.1313 0,-0.18708 0.10056,-0.20112 0.20612,-0.41188 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.5694 1.30962,-0.93544 0.54898,-0.51239 0.93544,-1.1849 1.49671,-1.6838 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92186 1.87088,3.18051 0.43731,0.6013 1.03151,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.50419 2.88136,-0.99924 4.30303,-0.74835 1.7318,0.30561 1.87761,0.85782 3.55469,1.4967 1.58485,0.60376 3.19072,0.93545 4.8643,0.93545",
    id: "path39095"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 1.98438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 154.80973,141.99073 c -0.48355,0.95045 -1.02382,1.90763 -1.12253,2.99342 -0.11532,1.26852 -0.20263,2.79079 0.74835,3.74177 0.30514,0.30514 1.8811,-0.47963 2.05798,-0.56126 0.75967,-0.35062 1.5489,-0.65843 2.24506,-1.12254 0.93535,-0.62357 1.95851,-1.72761 2.99342,-2.24506 0.93977,-0.46988 3.21212,-1.34072 4.30304,-1.12253 1.48777,0.29755 1.30962,4.12443 1.30962,5.05139 0,0.18709 0,0.37418 0,0.56127 0,0.0624 -0.0624,0.18708 0,0.18708 0.0624,0 -0.0279,-0.1313 0,-0.18708 0.10056,-0.20112 0.20612,-0.41188 0.37418,-0.56127 0.40096,-0.35641 0.91743,-0.5694 1.30962,-0.93544 0.54898,-0.51239 0.93544,-1.1849 1.49671,-1.6838 1.08123,-0.9611 4.69407,-3.55469 6.17393,-3.55469 0.19918,0 1.68277,2.92186 1.87088,3.18051 0.43731,0.6013 1.03151,0.98348 1.6838,1.30962 1.07587,0.53794 2.55027,-0.73622 3.55469,-1.12253 1.3109,-0.50419 2.88136,-0.99924 4.30303,-0.74835 1.7318,0.30561 1.87761,0.85782 3.55469,1.4967 1.58485,0.60376 3.19072,0.93545 4.8643,0.93545",
    id: "path39097"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtch);
export default __webpack_public_path__ + "static/media/BTCH.2d2f7c60afde5ef8ea9f01bea88fab82.svg";
export { ForwardRef as ReactComponent };